var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssociateGoogleAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 73",
    width: 160,
    height: 73,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 73,
    rx: 36.5,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3 24.3a28.7 28.7 0 0 0-3.3-1.7s-6.8-5.1-9.8-6.5c-3-1.3-8.2-4.2-13.5-4-4.2 0-6.7.9-7.6 1.1-1.1.3-1.8.6-.6 1.2l4 2.5c3 1.8 6.7 4 8.4 4.3 1.5.4 4 1 7.3.9 3.7 0 5.5 1.6 6 2.2-.8-1-3.3-1.8-6.7-1.6-3.2.2-5.8 0-7.4-.5a65 65 0 0 1-8.9-3.7l-2.2.9c-.9.4-1.8 1.1-.5 1.5 1 .3 9.8 3.7 12.4 3.8 1.4.1 3.8.2 6.7-.4 3.4-.6 5.1.8 5.5 1.4a9.3 9.3 0 0 0-1.5 5.8c-12.2-2.3-16-3.5-18.8-4C15 26.6 8.8 31 8 36.3a12 12 0 0 0 2 8.5c2 3 4.5 5.5 4.9 6 .2.5.2 1.7.2 2.5 0 .9 1 1.7 1.7 1.7.4 0 7.6 2.5 7.6 2.5L35.2 61l.2-1.1c0-.9-.6-3-3-3.7L27 54.5c-.4-.1 0-.1.6-.7 1-1 2-2.3 2.5-3.4 2.2-5-.5-9.3-.5-9.3s1.7 1.9 2.3 5.2a10 10 0 0 1-1.8 7.5l1.5.5L43 42c.9-1 2.3-1.6 3-1.9 2.8-.8 6.2-2.5 7.1-3 .9-.6 2-2.7 2.2-3.2.3-.5.6-1.2.7-2 0-.2-1.4-2.3-1.4-2.3s-2.4-4.2-4.3-5.4ZM20.4 58c-.6.4-.8 1.4 0 2 .9.4 3.5-1.1 3.5-1.1l-2.6-1s-.4-.1-.9.1Z",
    fill: "#00BAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 35a1.5 1.5 0 0 0 0 3v-3Zm25 2.6c.6-.6.6-1.6 0-2.2L83.6 26a1.5 1.5 0 1 0-2.1 2.1l8.5 8.5-8.5 8.5a1.5 1.5 0 1 0 2.1 2.1l9.6-9.5ZM68 38h24v-3H68v3Z",
    fill: "#00BAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.8 37c0-1.6-.1-3.3-.4-4.8H128v9.2h12.8a11 11 0 0 1-4.8 7.1v6h7.7c4.5-4.1 7.1-10.2 7.1-17.5Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 60.3c6.4 0 11.8-2.1 15.7-5.8l-7.7-6a14.2 14.2 0 0 1-21.3-7.5h-8v6.2c4 7.7 12 13 21.3 13Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.7 41a14.3 14.3 0 0 1 0-9v-6.2h-8a23.5 23.5 0 0 0 0 21.4l6.2-4.8 1.8-1.4Z",
    fill: "#FBBC05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128 22.2a13 13 0 0 1 9.1 3.5l6.8-6.8a23.7 23.7 0 0 0-37.1 7l7.9 6c1.9-5.5 7.1-9.7 13.3-9.7Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociateGoogleAccount);
export default __webpack_public_path__ + "static/media/associate-google-account.95126f5c.svg";
export { ForwardRef as ReactComponent };